import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-634925e4")

_pushScopeId("data-v-634925e4")
const _hoisted_1 = { class: "forgot-password" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "input-field" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.alert.content = ''))
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, { onSubmit: _ctx.forgetPassword }, {
        default: _withId(({ errors }) => [
          _createVNode("h3", null, _toDisplayString(_ctx.t("input your email address")), 1),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Field, {
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email = $event)),
              name: "email",
              rules: "required|email"
            }, {
              default: _withId(({ field }) => [
                _createVNode(_component_InputText, _mergeProps({
                  id: "email",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  class: { 'p-invalid': errors.email },
                  placeholder: _ctx.t('email'),
                  type: "text"
                }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder"])
              ]),
              _: 2
            }, 1032, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "email",
              class: "p-error"
            })
          ]),
          _createVNode(_component_Button, {
            class: "-button -royalBlue",
            type: "submit"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('submit')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
})